/**
 * Shared metadata keys and formatting for asset detail display.
 * Used by AssetDetailPage and CreateVariantPage for consistent metadata grids.
 */

/** All metadata field keys per layer (display order). Labels always shown; empty value rendered as "—". */
export const METADATA_LABEL_KEYS: Record<string, string[]> = {
  L: [
    'energy', 'culturalOrigin', 'variantName', 'variantType', 'creatorDescription', 'outfitName', 'style',
    'styleCategory', 'occasion', 'colorScheme', 'primaryGarment', 'primaryColors', 'patterns', 'materials',
    'seasonality', 'timeOfDay', 'accessories', 'jewelryType', 'brandNames', 'priceRange', 'formality',
  ],
  M: [
    'energy', 'culturalOrigin', 'variantName', 'variantType', 'creatorDescription', 'tempo', 'moveName',
    'danceStyle', 'difficulty', 'bodyParts', 'choreographerName', 'substyle', 'complexity', 'intensity',
    'pace', 'movementStyle', 'spaceRequired', 'groupSize', 'skillLevelRequired', 'costumeRequirements',
    'performanceContext', 'audienceType', 'bpmRangeMin', 'bpmRangeMax', 'floorWork', 'partnered',
    'signatureMoves', 'techniquesRequired', 'propsNeeded',
  ],
  G: [
    'songName', 'artistName', 'albumName', 'releaseYear', 'duration', 'genre', 'mood', 'energy', 'tempo',
    'culturalOrigin', 'variantName', 'variantType', 'creatorDescription', 'style', 'bpm', 'key', 'timeSignature',
  ],
  S: [
    'energy', 'culturalOrigin', 'variantName', 'variantType', 'creatorDescription', 'starName', 'realName',
    'gender', 'ageGroup', 'ethnicity', 'bodyType', 'height', 'hairColor', 'hairLength', 'hairStyle',
    'eyeColor', 'skinTone', 'archetype', 'musicalStyle', 'careerStage', 'personalityTraits', 'vibe',
    'performanceContext', 'targetAudience', 'makeupType', 'colorPalette', 'hairTexture', 'hairTreatment',
    'hairAccessories', 'eyeMakeup', 'lipMakeup', 'faceMakeup', 'makeupEffects',
  ],
  W: [
    'energy', 'culturalOrigin', 'variantName', 'variantType', 'creatorDescription', 'mood', 'timeOfDay',
    'season', 'versatility', 'culturalContext', 'style', 'worldName', 'locationType', 'lighting',
    'dominantColors', 'atmosphere', 'weather', 'setting', 'environmentType', 'lightingStyle', 'spatialSize',
    'settingCategory', 'specificLocation', 'spaceSize', 'layout', 'depth', 'colorPalette', 'lightingDirection',
    'vibe', 'geographicRegion', 'architecturalStyle', 'backdropType', 'productionValue', 'technicalComplexity',
    'movementSpace', 'audioAcoustics', 'crowdCapacity',
  ],
};

export function formatLabel(key: string): string {
  return key.replace(/([A-Z])/g, ' $1').replace(/^./, (s) => s.toUpperCase()).trim();
}
